import { Injectable } from '@angular/core';
import { APP_ROUTES } from '@app/constants';
import { API_URLS } from '@app/constants/apiUrls';
import { ApiHelper } from '@app/helpers';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(private apiHelper: ApiHelper) { }

  list() {
    return this.apiHelper.get(API_URLS.SURVEY)
  }

  add(payload: any) {
    return this.apiHelper.post(API_URLS.SURVEY, payload)
  }

  update(id: string, payload: any) {
    return this.apiHelper.put(`${API_URLS.SURVEY}/${id}`, payload)
  }

  clone(id: string) {
    return this.apiHelper.post(`${API_URLS.SURVEY}/${id}/clone`, {})
  }

  delete(id: string) {
    return this.apiHelper.delete(`${API_URLS.SURVEY}/${id}`)
  }

  reorder(id: string, payload: any) {
    return this.apiHelper.post(`${API_URLS.SURVEY}/${id}/re-order`, payload)
  }

  info(id: string) {
    return this.apiHelper.get(`${API_URLS.SURVEY}/${id}`)
  }
}
